// @flow
import React from 'react';
import LazyLoad from 'react-lazyload';

import './DesktopControls.css';

const THUMBNAIL_SIZE = 58;
const THUMBNAIL_WRAPPER_MARGIN_TOP = 15;

const getSliderTop = (firstThumbnail, maxThumbnails, imagesLength) => {
  if (imagesLength <= maxThumbnails) return 'auto';
  return firstThumbnail * -1 * THUMBNAIL_SIZE + THUMBNAIL_WRAPPER_MARGIN_TOP;
};

type Props = {|
  +images: Array<string>,
  +handleClickThumbnail: (number) => void,
  +currImage: number,
  +firstThumbnail: number,
  +maxThumbnails: number,
  +context: string,
|};

const DesktopControls = React.memo<Props>(
  ({
    images,
    handleClickThumbnail,
    currImage,
    firstThumbnail,
    maxThumbnails,
    context,
  }) => {
    return (
      <>
        <div
          className={`zoom-image-thumbnails ${
            images.length > maxThumbnails ? 'thumbnail-slider-wrapper' : ''
          } ${context ? `zoom-image-thumbnails-${context}` : ''}`}
        >
          <div
            className="thumbnail-slider"
            style={{
              top: getSliderTop(firstThumbnail, maxThumbnails, images.length),
            }}
          >
            {images.map((img, i) => (
              <div
                key={i}
                className={`zoom-image-thumbnail ${
                  i === currImage ? 'zoom-image-thumbnail-selected' : ''
                }`}
                onClick={() => handleClickThumbnail(i)}
              >
                <LazyLoad once>
                  <img alt="thumbnail" src={img} />
                </LazyLoad>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
);

export default DesktopControls;
